export enum ApplicationsLoadingEnum {
    Loading,
    Pagination,
    Deleting,
    Searching,
    Filtering,
    Adding,
    Creating,
    Updating,
    Refreshing
} 